import servicioHttp from './ServicioHttp';
import servicioObjetos from './ServicioObjetos';
import { deleteToken, deleteUsuario, setToken, setUsuario } from "../servicio/ServicioManejadorToken";

export function autenticar(usuario, contrasena) {
    return new Promise(function (resolve, reject) {
        deleteToken();
        deleteUsuario(); 
        var usuariob64 = btoa(usuario);
        var contrasenia = btoa(contrasena);  
        servicioHttp.consumirPostHttp(encodeURI('/autenticar?usuario='+usuariob64+'&contrasena='+contrasenia)).then((response) => {
            let tokenAutorizacion = response.headers.authorization;
            let usuarioSistema = response.headers.user;
            setToken(tokenAutorizacion);
            setUsuario(usuarioSistema);
            resolve("autenticado");
        }).catch((error) => {            
            if (!servicioObjetos.esObjetoVacio(error.response)) {
                if (error.response.status === 401) {
                    if (!servicioObjetos.esObjetoVacio(error.response.data)) {
                        reject(error.response.data.mensaje);
                    }
                } else {
                    reject("Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde");
                }
            }else{
                reject("Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde");
            }
        });
    });
}